import { useEffect, useContext} from "react"
import {useEstadoApp} from "../context/EstadoAppContext";
//import { AuthContext } from '../context/authContext';

export const MetabasePage = () => {

    const {estadoAppX, cambiarEstadoApp} = useEstadoApp();

    useEffect(() => {
        //console.log("estadoAppX", estadoAppX)
        cambiarEstadoApp("inicial")
    }, []) //cuando se monta el componente volver al estado inicial
    //const {isAuthenticated} = useContext(AuthContext)    

    return (
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 dark:bg-black dark:text-white">
            <div className="w-full sm:mx-auto sm:w-full sm:max-w-sm">
                <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:bg-black dark:text-white">
                    EN DESARROLLO: Tableros Metabase - Privado
                </h2>               
            </div>            
        </div>
    )
}